function isNull(value) {
    return value === null;
}

export { isNull };
